/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeMiniReference
 */
export interface TapeMiniReference {
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    readonly generation?: number;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly customA?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly customB?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly customC?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly customD?: string;
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    readonly freeSpace?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    readonly loadCounter?: number;
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    readonly errorCounter?: number;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly errorReason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TapeMiniReference
     */
    readonly active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TapeMiniReference
     */
    readonly lto?: TapeMiniReferenceLtoEnum;
    /**
     * 
     * @type {number}
     * @memberof TapeMiniReference
     */
    readonly group?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum TapeMiniReferenceLtoEnum {
    _5 = '5',
    _6 = '6',
    _7 = '7'
}

export function TapeMiniReferenceFromJSON(json: any): TapeMiniReference {
    return TapeMiniReferenceFromJSONTyped(json, false);
}

export function TapeMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'generation': !exists(json, 'generation') ? undefined : json['generation'],
        'customA': !exists(json, 'custom_a') ? undefined : json['custom_a'],
        'customB': !exists(json, 'custom_b') ? undefined : json['custom_b'],
        'customC': !exists(json, 'custom_c') ? undefined : json['custom_c'],
        'customD': !exists(json, 'custom_d') ? undefined : json['custom_d'],
        'freeSpace': !exists(json, 'free_space') ? undefined : json['free_space'],
        'loadCounter': !exists(json, 'load_counter') ? undefined : json['load_counter'],
        'errorCounter': !exists(json, 'error_counter') ? undefined : json['error_counter'],
        'errorReason': !exists(json, 'error_reason') ? undefined : json['error_reason'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'lto': !exists(json, 'lto') ? undefined : json['lto'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function TapeMiniReferenceToJSON(value?: TapeMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


